import type { QueryClient, QueryKey } from '@tanstack/react-query'
import { matchQuery } from '@tanstack/react-query'

import { isCommittedTaskWriteError, isLostResponseError } from './error-utils'

export const needsMutationReconciliation = (error: unknown): boolean =>
  isLostResponseError(error) || isCommittedTaskWriteError(error)

/** One pass refetches each matching active query once, even when prefixes overlap. */
export function reconcileMutationQueries(
  client: QueryClient,
  keys: readonly QueryKey[],
): Promise<void> {
  return client.invalidateQueries({
    predicate: query => keys.some(queryKey => matchQuery({ queryKey }, query)),
  })
}
